export default __webpack_public_path__ + "static/media/meslay13.c2d75fc5.jpg";